import { useSettings } from './useSetting';

export function useTurnSent(state: string): [boolean, (sent: boolean) => void] {
	const { settings, setValue } = useSettings();
	const lastTurnSent = settings.lastTurnSent;
	function setTurnSent(sent: boolean) {
		setValue('lastTurnSent', sent ? state : undefined);
	}
	return [lastTurnSent === state, setTurnSent];
}
